const API_BASE =
  process.env.REACT_APP_API_URL ||
  "http://localhost:3001";

function getToken() {
  try {
    const a = JSON.parse(localStorage.getItem("auth") || "null");
    return a?.token || null;
  } catch {
    return null;
  }
}

export async function adminFetch(path, { method = "GET", body } = {}) {
  const token = getToken();
  if (!token) {
    const err = new Error("No auth token");
    err.status = 401;
    throw err;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const err = new Error(data?.error || data?.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}
